import NeighborhoodPageContent from "../NeighborhoodPageContent";

export default function Teatinos() {
  return <NeighborhoodPageContent slug="teatinos" />;
}